export const plateFormats = [
  {
    id: 'classic',
    label: 'ABC-123',
    type: 'standard',
    style: 'classic',
    country: 'HU',
    regex: /^[A-Z]{3}-\d{3}$/,
    image: '/plates/classic.png',
    flagicon: '/plates/flag-icon.png',
    placeholder: 'ABC-123',
  },
  {
    id: 'eu',
    label: 'ABC-123',
    type: 'standard',
    style: 'eu',
    country: 'HU',
    regex: /^[A-Z]{3}-\d{3}$/,
    image: '/plates/eu.png',
    flagicon: '/plates/eu-icon.png',
    placeholder: 'ABC-123',
  },
  {
    id: 'eu2',
    label: 'AB CD-123',
    type: 'extended',
    style: 'extended',
    country: 'HU',
    regex: /^[A-Z]{2}-[A-Z]{2}-\d{3}$/,
    image: '/plates/eu2.png',
    flagicon: '/plates/eu-icon.png',
    placeholder: 'AB CD-123',
  },
  {
    id: 'custom',
    label: 'PÉLDA-01',
    type: 'custom',
    style: 'custom',
    country: 'HU',
    regex: /^[A-ZÁÉÍÓÖŐÚÜŰ\-]{3,}-\d{2}$/,
    image: '/plates/custom.png',
    flagicon: '/plates/eu-icon.png',
    placeholder: 'PÉLDA-01',
  },
];
